import { useCallback, useState } from 'react';
import type { StageElementT } from '../../types';
export const useStageElement = () => {
  const [elements, setElements] = useState<ReadonlyArray<StageElementT>>([]);
  const addElement = useCallback((element: StageElementT) => {
    if (elements.find(existingElement => existingElement.name === element.name)) {
      return;
    }
    setElements([...elements, element]);
  }, [elements]);
  const removeElement = useCallback((elementName: string) => {
    setElements(elements.filter(element => element.name !== elementName));
  }, [elements]);
  return {
    elements,
    removeElement,
    addElement
  };
};